const dod = [
    {
        text: "Compact Earbuds from Urbn at 999 la…",
        img: "https://m.media-amazon.com/images/I/31XCRJqeTjL._AC_SY200_.jpg"
    },
    {
        text: "Branded Suitcase, Backpacks and Duffl…",
        img: "https://m.media-amazon.com/images/I/31G-ftiDlPL._AC_SY200_.jpg"
    },
    
    {
        text: "Lava Blaze 5G (6GB) available…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Compact Earbuds from Urbn at 999 la…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Branded Suitcase, Backpacks and Duffl…",
        img: "https://m.media-amazon.com/images/I/31G-ftiDlPL._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available at Rs. 1…",
        img: "https://m.media-amazon.com/images/I/41CK1CvkW6L._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available at Rs. 1…",
        img: "https://m.media-amazon.com/images/I/41CK1CvkW6L._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Compact Earbuds from Urbn at 999 la…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Branded Suitcase, Backpacks and Duffl…",
        img: "https://m.media-amazon.com/images/I/31G-ftiDlPL._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available at Rs. 1…",
        img: "https://m.media-amazon.com/images/I/41CK1CvkW6L._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Compact Earbuds from Urbn at 999 la…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Branded Suitcase, Backpacks and Duffl…",
        img: "https://m.media-amazon.com/images/I/31G-ftiDlPL._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available at Rs. 1…",
        img: "https://m.media-amazon.com/images/I/41CK1CvkW6L._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Compact Earbuds from Urbn at 999 la…",
        img: "https://m.media-amazon.com/images/I/41YkhXo7qgL._AC_SY200_.jpg"
    },
    {
        text: "Lava Blaze 5G (6GB) available at Rs. 1…",
        img: "https://m.media-amazon.com/images/I/81TBkVDGeGL._AC_SY200_.jpg"
    }
]
export default dod;
